

export class CountryWithStateOutputStateData implements ICountryWithStateOutputStateData {
    /** The auto-generated id of the state master */
    state_id!: number;
    /** The state name with 255 character limit */
    state_name!: string;

    constructor(data?: ICountryWithStateOutputStateData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state_id = _data["state_id"];
            this.state_name = _data["state_name"];
        }
    }

    static fromJS(data: any): CountryWithStateOutputStateData {
        data = typeof data === 'object' ? data : {};
        let result = new CountryWithStateOutputStateData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state_id"] = this.state_id;
        data["state_name"] = this.state_name;
        return data; 
    }
}

export interface ICountryWithStateOutputStateData {
    /** The auto-generated id of the state master */
    state_id: number;
    /** The state name with 255 character limit */
    state_name: string;
}

